import React from 'react'
import PropTypes from 'prop-types'
import BlogPostHero from './BlogPostHero'
import BlogPostContent from './BlogPostContent'

function BlogPost({ data }) {
  return (
    <section className="blog-post">
      <div className="blog-hero-general-box">
        <BlogPostHero data={data} />
      </div>
      <div className="blog-content-general-box">
        <BlogPostContent data={data} />
      </div>
    </section>
  )
}

BlogPost.propTypes = {
  data: PropTypes.object.isRequired
}

export default BlogPost
